import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Route } from '../interfaces/route';
import { MessageService } from '../services/message.service';

@Injectable({
  providedIn: 'root'
})
export class SystemWideService {

  private systemWide: any = [];
  private alertDetailsUrl = 'https://www3.septa.org/api/Alerts/?req1=generic';

  constructor(private http: HttpClient,  private messageService: MessageService) { }

  get (): Observable<any[]> {

    this.systemWide = this.http.jsonp<Route[]>(this.alertDetailsUrl, 'callback')
    .pipe(
      map ((array: any) => array = this.transform(array)),
      tap (_ => this.log('fetched routes')),
      catchError (this.handleError<Route[]>('get', []))
    );
    return this.systemWide;
  }

  private transform(reponse: any): Route[]{
    var transformed: Route[] = [];
    for (const d of (reponse as any)){
      if(d.route == 'SYS'){
        transformed.push( {
          id: d.route,
          legacy: d.route_id,
          name: d.route_name.replace('/', ' '),
          mode: d.mode,
          sequence: 0,
          description: d.description,
          alert: d.alert,
          advisory: '',
          detours: d.detour,
          elevators: d.elevator,
          isalert: (d.current_message === '') ? false : true,
          isadvisory: false,
          isdetour: false,
          isdelays: false,
          iselevator: false,
          isweather: false,
          issuspended: false
        });
      }
    }
    return transformed;
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a RouteService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`RouteService: ${message}`);
  }
}
